/* global axios */
import ApiClient from '../ApiClient';

// Aceleres — título e descrição da página apontada por um link da conversa.
// Alimenta o cartão da aba "Links" no painel de contato.
class AceleresLinkPreviewsAPI extends ApiClient {
  constructor() {
    super('aceleres/link_previews', { accountScoped: true });
  }

  show(url) {
    return axios.get(this.url, { params: { url } });
  }
}

export default new AceleresLinkPreviewsAPI();
